// Calcul de la répartition d'une facture (identique au contrôle serveur) : écart d'arrondi ajouté au dernier véhicule
export const r2 = (x) => Math.round((Number(x) || 0) * 100 + 1e-7) / 100;
const sum = (a) => a.reduce((s, x) => s + (Number(x) || 0), 0);

export function invoiceTotals(inv) {
    const T = r2(inv.montant_ttc);
    const rate = Number(inv.taux_tva || 20) / 100;
    const H = inv.montant_ht ? r2(inv.montant_ht) : r2(T / (1 + rate));
    return { T, H, rate };
}

export function computeSplit(lines, mode, base, inv) {
    const { T, H, rate } = invoiceTotals(inv);
    const n = lines.length;
    const vals = lines.map(l => Number(String(l.valeur ?? '').replace(',', '.')) || 0);
    let ttc;
    if (mode === 'egale') ttc = lines.map(() => Math.floor((T / (n || 1)) * 100 + 1e-7) / 100);
    else if (mode === 'pourcentage') ttc = vals.map(p => r2((T * p) / 100));
    else ttc = vals.map(v => (base === 'ht' ? r2(v * (1 + rate)) : r2(v)));
    const full = n > 0 && (mode === 'egale' || (mode === 'pourcentage' && Math.abs(sum(vals) - 100) < 1e-6)
        || (mode !== 'pourcentage' && base === 'ht' && Math.abs(sum(vals) - H) < 0.005));
    let ecart = 0;
    if (full) {
        const before = ttc[n - 1];
        ttc[n - 1] = r2(T - sum(ttc.slice(0, -1)));
        ecart = r2(ttc[n - 1] - before);
    }
    const reparti = r2(sum(ttc));
    const reste = r2(T - reparti);
    const ok = Math.abs(reste) < 0.005;
    let acc = 0;
    const rows = ttc.map((t, i) => {
        const ht = ok && i === n - 1 ? r2(H - acc) : r2(t / (1 + rate));
        acc = r2(acc + ht);
        return { ttc: t, ht, tva: r2(t - ht) };
    });
    return { T, H, rows, reparti, reste, ecart, ok, pctTotal: r2(sum(vals)) };
}

export function splitProblems(lines, mode, calc) {
    const p = [];
    if (lines.length < 2) p.push('Ajoutez au moins deux lignes');
    if (!lines.some(l => l.type === 'vehicule')) p.push('Au moins une ligne doit concerner un véhicule');
    lines.forEach((l, i) => {
        if (l.type === 'vehicule' && !l.vehicle) p.push(`Ligne ${i + 1} : ${l.plaque_saisie ? `véhicule ${l.plaque_saisie} introuvable` : 'véhicule à choisir'}`);
        if (!(calc.rows[i]?.ttc > 0)) p.push(`Ligne ${i + 1} : montant à saisir`);
        if (mode === 'lignes' && !(l.description || '').trim()) p.push(`Ligne ${i + 1} : décrivez l'intervention`);
        const ex = l.type === 'vehicule' && Number.isInteger(l.frais_idx) ? (l.vehicle?.frais || []).find(f => f.idx === l.frais_idx) : null;
        if (ex && Math.abs(Number(ex.montant_ttc || 0) - (calc.rows[i]?.ttc || 0)) > 0.01) p.push(`Ligne ${i + 1} : le montant doit égaler la dépense existante (${Number(ex.montant_ttc || 0).toFixed(2).replace('.', ',')} €)`);
    });
    if (!calc.ok) p.push(`Reste à affecter : ${calc.reste.toFixed(2).replace('.', ',')} €`);
    const ex = lines.filter(l => l.type === 'vehicule' && l.vehicle && Number.isInteger(l.frais_idx)).map(l => `${l.vehicle.id}:${l.frais_idx}`);
    if (new Set(ex).size !== ex.length) p.push('La même dépense existante est choisie deux fois');
    return p;
}

export const toPayload = (lines, mode, base, calc) => ({
    mode, base,
    lignes: lines.map((l, i) => ({
        type: l.type, vehicle_id: l.type === 'vehicule' ? l.vehicle?.id || null : undefined, plaque_saisie: l.plaque_saisie || '',
        montant_ttc: calc.rows[i]?.ttc || 0, valeur: l.valeur, description: l.description || '', categorie: l.categorie,
        frais_idx: l.type === 'vehicule' && Number.isInteger(l.frais_idx) ? l.frais_idx : null,
    })),
});
